export const errorFormat = (errors) => {
    return Object.fromEntries( Object.entries(errors).map(([key, value]) => [key.split('.')[0], value[0]]) );
};